module.exports = __webpack_public_path__ + "avatar7.svg?2901525c164f34e24ba12a31922af773";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar7.svg
// module id = 143
// module chunks = 2